// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

/**
 * UX audit 2026-10-04 (P0 B6): "Generate invoice (last month)" sent the 1st of last month through the
 * END OF THIS MONTH — two months — and built the dates with toISOString(), which is UTC, so an
 * evening click in a US time zone could shift either end by a day. The period is now exactly the
 * previous calendar month, as local dates.
 */
const ymd = (d: Date) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`

export function previousMonthPeriod(now: Date = new Date()): { period_start: string; period_end: string } {
  const start = new Date(now.getFullYear(), now.getMonth() - 1, 1)
  const end = new Date(now.getFullYear(), now.getMonth(), 0)   // day 0 of this month = last day of the previous one
  return { period_start: ymd(start), period_end: ymd(end) }
}
